<div class="p-d-flex p-jc-center" style="bottom: 0; left: 0; position: fixed; width: 100%; padding-bottom: calc(env(safe-area-inset-bottom, 0) + 10px)">
    <ng-container *ngIf="count > 0">
        <button pButton class="p-button-rounded" label="{{count}} Selected" title="Show all selected segments" icon="pi pi-chevron-up" (click)="showingDialog = true"></button>
        <button pButton class="p-ml-1 p-button-secondary p-button-rounded" title="Clear all selected segments from the selection list" icon="pi pi-times" (click)="clipboardService.clear()"></button>
    </ng-container>
</div>

<p-confirmPopup key="clipboard-delete"></p-confirmPopup>

<p-dialog header="Selected Segments" position="bottom" [(visible)]="showingDialog" appendTo="body" [dismissableMask]="true" [modal]="true" [draggable]="false" [resizable]="false" [style]="{width: '750px'}">
    <p-table *ngIf="showingDialog" [value]="segments">
        <ng-template pTemplate="header">
            <tr>
                <th *ngIf="hasError" style="width: 10%"></th>
                <th>Template</th>
                <th>Type</th>
                <th>Content</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td *ngIf="hasError" style="width: 10%">
                    <ng-container *ngIf="errorMap[item.data.id]">
                        <span [title]="errorMap[item.data.id]" class="pi pi-exclamation-triangle clickable" (click)="overlayPanel.show($event)" style="color: red"></span>
                        <p-overlayPanel #overlayPanel appendTo="body" [showCloseIcon]="true">
                            <span>{{errorMap[item.data.id]}}</span>
                        </p-overlayPanel>
                    </ng-container>
                </td>
                <td>
                    {{clipboardService.getTemplate(item.data.templateId)?.name}}
                </td>
                <td>
                    {{item.data.type.id === SEGMENT_TYPE.SUB_TEMPLATE ? clipboardService.getTemplate(item.data.templateId)?.templateType?.id === TEMPLATE_TYPE.INSPECTION ? 'Section' : 'Sub Template' : item.data.type.name }}
                </td>
                <td>
                    <div class="p-d-flex p-flex-column">
                        <span>{{getSegmentContent(item.data)}}</span>
                    </div>
                </td>
                <td class="p-text-right">
                    <button pButton title="Remove {{item.data.name || item.data.text}} from the selection list" class="p-button-outlined p-button-secondary" label="Clear"
                            (click)="clipboardService.remove(item)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div class="p-grid p-nogutter p-mt-2">
            <div class="p-col-6 p-text-left">
                <button *ngIf="showDeleteButton" pButton class="p-button-rounded p-button-danger" title="Delete all selected segments from the template" icon="pi pi-trash" label="Delete Selected" (click)="presentDeleteConfirmation($event)"></button>
            </div>
            <div class="p-col-6 p-text-right">
                <button pButton class="p-button-rounded p-button-secondary" title="Clear all selected segments from the selection list" label="Clear Selection" (click)="clipboardService.clear(); showingDialog = false"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>